import clsx from "clsx";

const LoadingIcon = ({ width = "21", height = "20", type = "primary" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
    >
      <g id="Buttons/Button loading icon">
        <path
          id="Background"
          opacity="0.3"
          d="M19.5 10C19.5 11.1819 19.2672 12.3522 18.8149 13.4442C18.3626 14.5361 17.6997 15.5282 16.864 16.364C16.0282 17.1997 15.0361 17.8626 13.9441 18.3149C12.8522 18.7672 11.6819 19 10.5 19C9.3181 19 8.14778 18.7672 7.05585 18.3149C5.96392 17.8626 4.97176 17.1997 4.13604 16.364C3.30031 15.5282 2.63738 14.5361 2.18508 13.4441C1.73279 12.3522 1.5 11.1819 1.5 10C1.5 8.8181 1.73279 7.64778 2.18509 6.55585C2.63738 5.46392 3.30031 4.47176 4.13604 3.63604C4.97177 2.80031 5.96392 2.13737 7.05585 1.68508C8.14778 1.23279 9.31811 0.999999 10.5 1C11.6819 1 12.8522 1.23279 13.9442 1.68509C15.0361 2.13738 16.0282 2.80031 16.864 3.63604C17.6997 4.47177 18.3626 5.46392 18.8149 6.55585C19.2672 7.64778 19.5 8.81811 19.5 10L19.5 10Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={clsx({
            "stroke-primaryLoading": type === "primary",
            "stroke-secondaryLoading": type === "secondary",
          })}
        />
        <path
          id="Line"
          d="M10.5 1C11.6819 1 12.8522 1.23279 13.9442 1.68508C15.0361 2.13738 16.0282 2.80031 16.864 3.63604C17.6997 4.47177 18.3626 5.46392 18.8149 6.55585C19.2672 7.64778 19.5 8.8181 19.5 10"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={clsx({
            "stroke-primaryLoading": type === "primary",
            "stroke-secondaryLoading": type === "secondary",
          })}
        />
      </g>
    </svg>
  );
};

export default LoadingIcon;
